import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import classNames from 'classnames'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'

const useStyles = makeStyles(theme => ({
    root: {
        color: theme.primary
    },
    rootLabel: {
        fontSize: 14,
        display: 'flex',
        alignItems: 'center'
    },
    labelText: {
        wordBreak: 'break-word'
    },
    checkboxRoot: {
        color: theme.quaternary
    },
    checkboxChecked({ inverted }) {
        return {
            color: inverted ? 'inherit' : `${theme.primary} !important`
        }
    }
}))

export default function CustomCheckbox(props) {
    const classes = useStyles({ inverted: props.inverted })

    const {
        label,
        onClick,
        checked,
        disabled,
        className,
        customOnClick,
        ...restProps
    } = props

    return (
        <FormControlLabel
            className={classNames(classes.root, className)}
            classes={{
                label: classes.rootLabel
            }}
            label={<div className={classes.labelText}>{label}</div>}
            disabled={disabled}
            control={
                <Checkbox
                    classes={{
                        root: classes.checkboxRoot,
                        checked: classes.checkboxChecked
                    }}
                    onChange={onClick}
                    onClick={customOnClick}
                    checked={checked}
                    disabled={disabled}
                    size="small"
                    {...restProps}
                />
            }
        />
    )
}
